import {Component} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  templateUrl: './form-switch.component.html'
})
export class FormSwitchComponent {
  config;
  grupo: FormGroup;

}
